import React from 'react';
import PropTypes from 'prop-types';
import { List, Typography } from '@one-thd/sui-atomic-components';
import { LinkRefinement } from '../Refinements/CategoryRefinement/LinkRefinement';
import { NestedLinkRefinement } from '../Refinements/CategoryRefinement/NestedLinkRefinement';
import { getInitialItemsToShowCount } from '../../utils/showMoreLessUtility';

const LinkDimension = ({
  breadCrumbs,
  dimension,
  onChange
}) => {

  const getRefinementId = (refinement, refinementIndex) => {
    const { refinementKey } = refinement;
    return `${refinementKey}-${refinementIndex}`;
  };

  const breadCrumbsCategories = Array.isArray(breadCrumbs)
    ? breadCrumbs.filter((breadCrumb) => (breadCrumb?.dimensionName === 'Category'))
    : [];

  const { label: categoryLabel = '', url: categoryUrl = '' } = breadCrumbsCategories.pop() || {};
  const { refinements = [] } = dimension || {};

  const hasCategoryLabel = Boolean(categoryLabel?.trim());

  return (
    <div
      className="sui-mb-3"
      data-testid="categoryDrawerFilter"
    >
      {breadCrumbsCategories?.length > 0 && (
        <>
          <List role="list" disablePadding>
            {breadCrumbsCategories.map((category, categoryIndex) => {
              const id = getRefinementId(category, categoryIndex);
              return (
                <LinkRefinement
                  arrow
                  dimension={dimension}
                  id={id}
                  key={id}
                  onChange={onChange}
                  refinement={category}
                />
              );
            })}
          </List>
        </>
      )}
      {
        hasCategoryLabel && (
          <div className="sui-mt-2 sui-mb-2">
            {/* SEO-friendly hidden link - Required for SEO significance. Reach out to SEO team if wanting to change */}
            <a
              href={categoryUrl}
              className="sui-hidden"
              aria-hidden="true"
              tabIndex="-1"
            >
              {/* H3 element required for SEO significance. Reach out to SEO team if wanting to change */}
              <h3>{categoryLabel}</h3>
            </a>

            {/* Interactive visible element */}
            <Typography
              variant="body-base"
              weight="bold"
              onClick={(event) => {
                event.preventDefault();
                if (onChange) {
                  onChange({ refinement: { label: categoryLabel, url: categoryUrl }, dimension });
                }
              }}
            >
              {categoryLabel}
            </Typography>
          </div>
        )
      }
      {refinements?.length > 0 && (
        <div className="sui-overflow-y-auto">
          <List role="list" disablePadding>
            <List role="list" disablePadding>
              {refinements.map((refinement, refinementIndex) => {
                const id = getRefinementId(refinement, refinementIndex);
                return (
                  <LinkRefinement
                    dimension={dimension}
                    id={id}
                    key={id}
                    onChange={onChange}
                    refinement={refinement}
                    hasBoldStyle={!hasCategoryLabel && refinementIndex === 0}
                    refinementIndex={refinementIndex}
                  />
                );
              })}
            </List>
          </List>
        </div>
      )}
    </div>
  );
};

LinkDimension.propTypes = {
  breadCrumbs: PropTypes.arrayOf(
    PropTypes.shape({})
  ).isRequired,
  dimension: PropTypes.shape({
    dimensionId: PropTypes.string,
    label: PropTypes.string,
    refinements: PropTypes.arrayOf(
      PropTypes.shape({})
    )
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

export { LinkDimension };
